import { axiosDS } from '@pp/axios'
import { SimpleResponse } from 'Types/simpleResponse'
import { urls } from 'Constants/Urls'
import { BgLimitRequestFull, DigitalLeadBg, PaperLeadBg, RequestType } from 'Pages/ibro'

export const bgLimitRequestLeadApi = {
	limitAgreeDigitalLead: async (request_type: RequestType, id: number, data: DigitalLeadBg) => {
		const res = await axiosDS().post<SimpleResponse>(urls.broker.limit_create_digital_lead, {
			request_type,
			request_id: id,
			data,
		})
		return res.data
	},

	limitChangeLead: async (id: number, lead_id: number) => {
		const res = await axiosDS().patch<BgLimitRequestFull>(
			urls.broker.limit_change_lead.replace(':id', id.toString()),
			{
				data: { lead_id },
			}
		)
		return res.data
	},

	limitAgreeConfirmation: async (request_type: RequestType, request_id: number, phone: string) => {
		const res = await axiosDS().post<SimpleResponse>(urls.broker.limit_confirmation, {
			request_type,
			request_id,
			data: { phone },
		})
		return res.data
	},

	limitAgreePaperLead: async (request_type: RequestType, id: number, data: PaperLeadBg) => {
		const res = await axiosDS().post<SimpleResponse>(urls.broker.limit_create_paper_lead, {
			request_type,
			request_id: id,
			data,
		})
		return res.data
	},
}
